
import React,{useEffect, useState} from 'react';
import { Col, Row, Form, Card } from 'react-bootstrap';
import { books_category, author_details, publisher_details, bookClassification } from '../../ProData';
import AutoComplete from '../../components/AutoComplete';

// Modern styles for BooksForm
const booksFormModernStyles = `
  .booksform-card {
    background: #fff;
    border-radius: 18px;
    box-shadow: 0 4px 16px 0 rgba(44, 62, 80, 0.09);
    padding: 1.5rem 1.2rem 1.2rem 1.2rem;
    margin-bottom: 2rem;
    font-family: Inter, Segoe UI, Arial, sans-serif;
  }
  .booksform-label {
    font-weight: 600;
    color: #2a3659;
    margin-bottom: 0.3rem;
    letter-spacing: 0.2px;
  }
  .booksform-input, .booksform-select {
    border-radius: 10px !important;
    font-size: 1.05rem;
    padding: 10px 14px;
    border: 1px solid #e3eafc;
    background: #fafdff;
    margin-bottom: 0.5rem;
    transition: border 0.2s, box-shadow 0.2s;
  }
  .booksform-input:focus, .booksform-select:focus {
    border: 1.5px solid #4f8cff;
    box-shadow: 0 2px 8px 0 rgba(44, 62, 80, 0.09);
    background: #fff;
  }
  .booksform-required {
    color: #ff5252;
    margin-left: 2px;
    font-size: 1.1em;
    vertical-align: middle;
  }
  .booksform-img-preview {
    width: 6rem;
    height: 6rem;
    border-radius: 12px;
    object-fit: cover;
    box-shadow: 0 2px 8px rgba(44,62,80,0.09);
    margin-bottom: 0.5rem;
  }
  .booksform-img-upload {
    display: inline-block;
    margin-top: 0.5rem;
  }
  .booksform-img-upload input[type="file"] {
    display: none;
  }
  .booksform-img-upload label {
    background: linear-gradient(90deg, #4f8cff 0%, #6ed0fa 100%);
    color: #fff;
    border-radius: 8px;
    padding: 7px 18px;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.2s, box-shadow 0.2s, transform 0.2s;
    box-shadow: 0 2px 8px 0 rgba(44, 62, 80, 0.07);
    margin-bottom: 0.5rem;
    display: inline-block;
  }
  .booksform-img-upload label:hover, .booksform-img-upload label:focus {
    background: linear-gradient(90deg, #063547 60%, #7ee8fa 100%);
    color: #fff;
    transform: translateY(-2px) scale(1.03);
    box-shadow: 0 4px 16px 0 rgba(44, 62, 80, 0.13);
  }
  @media (max-width: 900px) {
    .booksform-card {
      padding: 1rem 0.5rem 0.7rem 0.5rem;
      border-radius: 10px;
    }
    .booksform-label {
      font-size: 1rem;
    }
    .booksform-input, .booksform-select {
      font-size: 0.98rem;
      padding: 8px 10px;
    }
  }
  @media (max-width: 600px) {
    .booksform-card {
      padding: 0.5rem 0.1rem 0.3rem 0.1rem;
      border-radius: 7px;
    }
    .booksform-label {
      font-size: 0.97rem;
    }
    .booksform-input, .booksform-select {
      font-size: 0.95rem;
      padding: 7px 7px;
    }
    .booksform-img-preview {
      width: 4.5rem;
      height: 4.5rem;
    }
  }
`;

export default function BooksForm(props) {
    const {bookDetails, setBookDetails, viewOnly, formType, dispMsg} = props;
    const { setNewFileName, setImageFile, profileImage }=props;
    const inputRef = React.useRef();
    const [loaded, setLoaded] = useState(true);

    useEffect(()=>{
      //console.log("book details  :", bookDetails);
      //console.log("profile image  :", formType);
      if(formType==="View" || formType==="Edit" || formType==="Clone"){
        if(bookDetails.Book_Classification_No && bookDetails.Book_Classification_No.length>=3){
          const tinputValue= bookDetails.Book_Classification_No;
          handleCategorySelection(tinputValue);
        }
      }
            // return()=>setBookDetails({...bookDetails, autoGenerate:true});      
    },[profileImage])

    const handleSelection=(e)=>{
     // e.preventDefault();
      setBookDetails({...bookDetails, autoGenerate:!bookDetails.autoGenerate});
    }

    const handleBookCategoryChange=(event)=>{
      const tbookno=books_category.filter((item)=>item.categoryName===event.target.value);
      //console.log(tbookno);
      setBookDetails({...bookDetails, 
        bookCategory:event.target.value,
        Book_Classification_No:tbookno[0].classficationNo
      });

    }

    const handleCategorySelection=(inputValue)=>{
      var filteredValue="OTHERS";
      //console.log("books category :", bookClassification);
      if(inputValue.length>=3){
       // const tinputValue= inputValue.substring(0,3);
        //console.log("3 char : ", tinputValue);
        const tempFilter= bookClassification.find(item=>item.value===inputValue);
        //console.log("filter : ", tempFilter);
        if(tempFilter){
          filteredValue=tempFilter.name;
        }
      }
      //console.log("filteredvalue :", filteredValue);
      setBookDetails({...bookDetails, bookCategory:filteredValue,
        Book_Classification_No:inputValue
      });
    }

    const handleFileSelection = (event)=>{
      setLoaded(false);
        event.preventDefault();
        if (event.target.files && event.target.files.length > 0) {
          setImageFile(event.target.files[0]);
          var tprofile = document.getElementById("profile");
          tprofile.src=URL.createObjectURL(event.target.files[0]);
      }
      setLoaded(true);
    }

    const handleImageError=()=>{
      document.getElementById("profile").src="images/cat1.png";
      //id.src="images/cat1.png";
    }


    
  return (
    <>
      <style>{booksFormModernStyles}</style>
      <Card className="booksform-card">
      <Card.Body>
        <Form autoComplete="off">
        {/*<div style={{backgroundColor:"#063547", borderRadius:"25px", color:"white", textAlign:"center"}}>
          <h1>{dispMsg}</h1>
          </div>*/}
          {formType==="New" || formType==="Clone" ? (
            <Row>
              <Col xs={12} md={6}  >
                <Form.Group id="Accession_No">
                  <Form.Check
                    type="switch"
                    id="custom-switch"
                    label={<span className="booksform-label">Input Accession No</span>}
                    isValid={bookDetails.autoGenerate}
                    onClick={(e) => handleSelection(e) }
                  />
                </Form.Group>
              </Col>
              {!bookDetails.autoGenerate && (
                <Col xs={12} md={6}  >
                  <Form.Group id="bookNo">
                    <Form.Label className="booksform-label">Accession No <span className="booksform-required">*</span></Form.Label>
                    <Form.Control required type="text" className="booksform-input"
                      value={bookDetails.Accession_No}  disabled={formType==="Edit" || formType==="View"?true:false}
                      onChange={event=>{setBookDetails({...bookDetails, Accession_No:(event.target.value).toUpperCase()})}}
                    />
                  </Form.Group>
                </Col>
              )}
            </Row>
          ) : null}
        <Row>
          <Col xs={12} md={6}>
            <Form.Group id="bookName">
              <Form.Label className="booksform-label">Book Name <span className="booksform-required">*</span></Form.Label>
              <Form.Control required type="text" className="booksform-input"
                value={bookDetails.Book_Title}  disabled={viewOnly}
                onChange={event=>{setBookDetails({...bookDetails, Book_Title:(event.target.value).toUpperCase()})}}
              />
            </Form.Group>
          </Col>
          <Col xs={12} md={6} >
            <Form.Group id="authorName">
              <Form.Label className="booksform-label">Tamil Book Name <span className="booksform-required"></span></Form.Label>
              <Form.Control required type="text" className="booksform-input"
                value={bookDetails.Tamil_Title}  disabled={viewOnly}
                onChange={event=>{setBookDetails({...bookDetails, Tamil_Title:event.target.value})}}
              />
            </Form.Group>
            </Col>
          </Row>
        <Row>
          <Col xs={12} md={6} >
            <Form.Group id="bookSubTitle">
              <Form.Label className="booksform-label">Book Sub Title <span className="booksform-required"></span></Form.Label>
              <Form.Control required type="text" className="booksform-input"
                value={bookDetails.bookSubTitle}  disabled={viewOnly}
                onChange={event=>{setBookDetails({...bookDetails, bookSubTitle:(event.target.value).toUpperCase()})}}
              />
            </Form.Group>
          </Col>
          <Col xs={12} md={6} >
            <Form.Group id="authorName">
              <Form.Label className="booksform-label">Author Name <span className="booksform-required">*</span></Form.Label>
              <Form.Control required type="text" className="booksform-input"
                value={bookDetails.Book_Author}  disabled={viewOnly}
                onChange={event=>{setBookDetails({...bookDetails, Book_Author:(event.target.value).toUpperCase()})}}
              />
            </Form.Group>
            </Col>
        </Row>
        <Row>
          <Col xs={12} md={6} >
            <Form.Group id="publisherName">
              <Form.Label className="booksform-label">Publisher Name <span className="booksform-required"></span></Form.Label>
              <Form.Control required type="text" className="booksform-input"
                value={bookDetails.Book_Publisher}  disabled={viewOnly}
                onChange={event=>{setBookDetails({...bookDetails, Book_Publisher:(event.target.value).toUpperCase()})}}
              />
            </Form.Group>
          </Col>
          <Col xs={6} md={3} >
            <Form.Group id="middleName">
              <Form.Label className="booksform-label">Publisher Location <span className="booksform-required"></span></Form.Label>
              <Form.Control required type="text" className="booksform-input"
                value={bookDetails.bookPublisherLocation} disabled={viewOnly}
                onChange={event=>{setBookDetails({...bookDetails, bookPublisherLocation:(event.target.value).toUpperCase()})}}                
              />
            </Form.Group>
          </Col>
          <Col xs={6} md={3}  >
            <Form.Group id="middleName">
              <Form.Label className="booksform-label">Publish Year <span className="booksform-required"></span></Form.Label>
              <Form.Control required type="text" className="booksform-input"
                value={bookDetails.Publishing_Year} disabled={viewOnly}
                onChange={event=>{setBookDetails({...bookDetails, Publishing_Year:(event.target.value).toUpperCase()})}}                
              />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={4}  >
            <Form.Group id="Book_Classification_No">
              <Form.Label className="booksform-label">Book Call No <span className="booksform-required">*</span></Form.Label>
              <Form.Control required type="text" className="booksform-input" value={bookDetails.Book_Classification_No}
                disabled={viewOnly} 
                onChange={(event)=>{handleCategorySelection(event.target.value)}}
              />
            </Form.Group>
          </Col>
          <Col xs={12} md={4}  >
            <Form.Group id="bookCategory">
              <Form.Label className="booksform-label">Book Category <span className="booksform-required">*</span></Form.Label>
              <Form.Control required type="text" className="booksform-input"
                disabled
                value={bookDetails.bookCategory}/>
            </Form.Group>
          </Col>
          <Col xs={12} md={4}  >
            <Form.Group id="Book_Classification_No">
              <Form.Label className="booksform-label">Author Mark <span className="booksform-required">*</span></Form.Label>
              <Form.Control required type="text" className="booksform-input" value={bookDetails.authorMark}
                disabled ={viewOnly} 
                onChange={(event)=>{setBookDetails({...bookDetails, authorMark:event.target.value})}}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={3}  >
            <Form.Group id="firstName">
              <Form.Label className="booksform-label">Status <span className="booksform-required">*</span></Form.Label>
              <Form.Select size="lg" className="booksform-select"
                disabled={viewOnly}
                value={bookDetails.Book_Status}
                onChange={event=>{setBookDetails({...bookDetails, Book_Status:event.target.value})}} 
              >
                <option value="Available">Available</option>
                <option value="In Active">In Active</option>
              </Form.Select>
            </Form.Group>
          </Col>
          <Col xs={12} md={3}  >
            <Form.Group id="isbn">
              <Form.Label className="booksform-label">ISBN <span className="booksform-required"></span></Form.Label>
              <Form.Control required type="text" className="booksform-input" value={bookDetails.isbn}
                disabled={viewOnly} 
                onChange={(event)=>{setBookDetails({...bookDetails, isbn:(event.target.value).toUpperCase()})}}
              />
            </Form.Group>
          </Col>
          <Col xs={12} md={3}  >
            <Form.Group id="applicantName">
              <Form.Label className="booksform-label">Book Price <span className="booksform-required"></span></Form.Label>
              <Form.Control required type="text" className="booksform-input" value={bookDetails.bookPrice}
                disabled={viewOnly} 
                onChange={(event)=>{setBookDetails({...bookDetails, bookPrice:event.target.value})}}
              />
            </Form.Group>
          </Col>
          <Col xs={12} md={3}  >
            <Form.Group id="bookPages">
              <Form.Label className="booksform-label">Book Pages <span className="booksform-required"></span></Form.Label>
              <Form.Control required type="text" className="booksform-input" value={bookDetails.bookPages}
                disabled={viewOnly} 
                onChange={(event)=>{setBookDetails({...bookDetails, bookPages:event.target.value})}}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={3}  >
            <Form.Group id="bookScope">
              <Form.Label className="booksform-label">Book Scope <span className="booksform-required"></span></Form.Label>
              <Form.Select size="lg" className="booksform-select"
                disabled={viewOnly}
                value={bookDetails.Book_Scope}
                onChange={event=>{setBookDetails({...bookDetails, Book_Scope:event.target.value})}} 
              >
                <option value="Circulation">Circulation</option>
                <option value="E-Books">E-Books</option>
              </Form.Select>
            </Form.Group>
          </Col>
          <Col xs={12} md={3}  >
            <Form.Group id="bookEdition">
              <Form.Label className="booksform-label">Book Edition <span className="booksform-required"></span></Form.Label>
              <Form.Control required type="text" className="booksform-input" value={bookDetails.bookEdition}
                disabled={viewOnly} 
                onChange={(event)=>{setBookDetails({...bookDetails, bookEdition:event.target.value})}}
              />
            </Form.Group>
          </Col>
          <Col xs={12} md={3}  >
            <Form.Group id="bookEdition">
              <Form.Label className="booksform-label">Copies <span className="booksform-required"></span></Form.Label>
              <Form.Control required type="number" className="booksform-input" value={bookDetails.bookCopies}
                disabled={viewOnly} 
                onChange={(event)=>{setBookDetails({...bookDetails, bookCopies:event.target.value})}}
              />
            </Form.Group>
          </Col>
          <Col xs={12} md={3}  >
            <Form.Group id="bookEdition">
              <Form.Label className="booksform-label">Book Dimension <span className="booksform-required"></span></Form.Label>
              <Form.Control required type="text" className="booksform-input" value={bookDetails.bookDimension}
                disabled={viewOnly} 
                onChange={(event)=>{setBookDetails({...bookDetails, bookDimension:event.target.value})}}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col xs={12}  >
            <Form.Group id="firstName">
              <Form.Label className="booksform-label">Book Keywords <span className="booksform-required"></span></Form.Label>
              <Form.Control required type="text" className="booksform-input"
                value={bookDetails.bookKeywords}  disabled={viewOnly}
                onChange={event=>{setBookDetails({...bookDetails, bookKeywords:event.target.value})}}
              />
            </Form.Group>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={8}  >
            <Form.Group id="firstName">
              <Form.Label className="booksform-label">Book Abstract <span className="booksform-required"></span></Form.Label>
              <Form.Control required as="textarea" rows={5} className="booksform-input"
                value={bookDetails.bookAbstract}  disabled={viewOnly}
                onChange={event=>{setBookDetails({...bookDetails, bookAbstract:event.target.value})}}
              />
            </Form.Group>
          </Col>
          <Col xs={12} md={4}  >
            <Form.Group id="firstName">
              <Form.Label className="booksform-label">Book Poster Image</Form.Label>
              <div style={{textAlign:"center"}}>
                <img id="profile" src={profileImage}
                  onError={handleImageError}
                  alt="Project Photo" className="booksform-img-preview" />
                {!viewOnly && (
                  <div className="booksform-img-upload">
                    <label htmlFor="book-image-upload">Upload Image</label>
                    <input
                      id="book-image-upload"
                      type="file"
                      accept="image/*"
                      ref={inputRef}
                      onChange={handleFileSelection}
                    />
                  </div>
                )}
              </div>
            </Form.Group>
          </Col>
        </Row>
        </Form>
      </Card.Body>
      </Card>
    </>
  )
}
